module.exports = __webpack_public_path__ + "static/logo_new_white_h-afef94d05097418a0cadf7487848b693.png";